module.exports = __webpack_public_path__ + "static/media/pagamento-boleto.ac0f2fdf.svg";